import React from 'react';
import sanitize from 'sanitize-html';
import SupportReturnStatusStyles from '@/components/SupportSection/SupportReturnStatus/SupportReturnStatusStyles';

const sanitizeSettings = {
  allowedTags: ['p'],
  allowedAttributes: {
    p: [''],
  },
};

const SupportReturnStatus = ({ data }) => {
  const {
    hero_title,
    hero_title_2,
    about_services,
  } = data;

  const service = about_services[0];

  return (
    <SupportReturnStatusStyles>
      <div className="support-container">
        <div className="title">
          {hero_title}
        </div>
        <div className='description' dangerouslySetInnerHTML={{ __html: sanitize(hero_title_2, sanitizeSettings) }} />
        <a href="/portal/#/tax-organizer/business" target="_blank" className="btn btn-primary">Check my Tax Return Status</a>
        <div className="video-container">
          <video name="Embedded Video" loop={true} autoPlay="autoplay" controls="controls" playsInline={true}>
            <source
              src={service.video_attachment}
              type="video/mp4"
            />
          </video>
        </div>
      </div>
    </SupportReturnStatusStyles>
  );
};

export default SupportReturnStatus;